export const getNextWrappingIndex = (currentIndex: number, listLength: number): number =>
  (currentIndex + 1) % listLength;
